import React from "react";
import { Resources, MaritalStatusValue } from "../../utils/resources";
import { useForm } from "../../contexts/FormContext";

const Step4: React.FC = () => {
  const {
    formData,
    updateField,
    validateField,
    isFieldTouched,
    touchedFields,
  } = useForm();

  const handleMaritalStatusChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = e.target.value as MaritalStatusValue;
    updateField("marital_status", value);
  };

  const handleDependantsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    updateField("dependents", e.target.value);
  };

  // Get validation errors for each field
  const maritalStatusError =
    isFieldTouched("marital_status") || touchedFields["marital_status"]
      ? validateField("marital_status", formData.marital_status || "")
      : null;

  const dependentsError =
    isFieldTouched("dependents") || touchedFields["dependents"]
      ? validateField("dependents", formData.dependents || "")
      : null;

  return (
    <div className="flex flex-col space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Who do you live with?</h1>
      </div>

      {/* Marital Status */}
      <div className="space-y-2">
        <label htmlFor="marital_status" className="block text-sm font-medium">
          Marital status
        </label>
        <select
          id="marital_status"
          value={formData.marital_status || ""}
          name="marital_status"
          onChange={handleMaritalStatusChange}
          className={`form-input-secondary ${
            maritalStatusError ? "border-red" : ""
          }`}
          aria-invalid={!!maritalStatusError}
          aria-describedby={
            maritalStatusError ? "marital-status-error" : undefined
          }
        >
          <option value="">Select an option</option>
          {Object.entries(Resources.maritalStatusOptions).map(
            ([label, value]) => (
              <option key={value} value={value}>
                {label}
              </option>
            )
          )}
        </select>
        {maritalStatusError && (
          <p
            className="mt-2 text-sm text-red"
            id="marital-status-error"
            role="alert"
          >
            {maritalStatusError}
          </p>
        )}
      </div>

      {/* Number of Dependants */}
      <div className="space-y-2">
        <label htmlFor="dependents" className="block text-sm font-medium">
          Number of dependants
        </label>
        <select
          id="dependents"
          value={formData.dependents || ""}
          name="dependents"
          onChange={handleDependantsChange}
          className={`form-input-secondary ${
            dependentsError ? "border-red" : ""
          }`}
          aria-invalid={!!dependentsError}
          aria-describedby={dependentsError ? "dependents-error" : undefined}
        >
          <option value="">Select an option</option>
          {Object.entries(Resources.numberOfDependantsOptions).map(
            ([label, value]) => (
              <option key={value} value={value}>
                {label}
              </option>
            )
          )}
        </select>
        {dependentsError && (
          <p
            className="mt-2 text-sm text-red"
            id="dependents-error"
            role="alert"
          >
            {dependentsError}
          </p>
        )}
      </div>
    </div>
  );
};

export default Step4;
